/* eslint-env browser */
import * as React from 'react'

import ContestStatsTable from './components/ContestStatsTable'

require('../../container/client')

const ReactDOM = require('react-dom')
const DomHelper = require('../../client/clientjs/dom-helper')
const ModalsHelper = require('../../client/clientjs/utils/modals')
const Catches = require('../../client/clientjs/components/CatchesGrid/Grid')
const AllCatches = require('./components/AllCatches')
const Teams = require('./components/Teams')
const RegisterButton = require('./components/RegisterButton')
const RegistrationModal = require('./components/RegistrationModal')
const CountDown = require('./components/CountDown')
const Ranking = require('./components/Ranking')
const RankingNoRounds = require('./components/RankingNoRounds')
const IndividualRankingRounds = require('./components/IndividualRankingRounds')
const IndividualRankingNoRounds = require('./components/IndividualRankingNoRounds')
const JoinContestTeam = require('./components/JoinContestTeam')
const JoinContestWithPassword = require('./components/JoinContestWithPassword')
const RegisterWithPayment = require('./components/RegisterWithPayment')

const initMap = require('./initMap')

DomHelper.onDocumentReady(() => {
  const renderElt = DomHelper.query('#react-render-contest-catches')
  if (renderElt) {
    ReactDOM.render(
      <Catches
        userSettings={window.initialState.userSettings}
        locale={window.initialState.locale.identifierShort}
        isLoggedIn={window.initialState.isLoggedIn}
        displayLikes
        loadMore={{ type: 'contest', contestId: window.initialState.contestId }}
      />,
      renderElt
    )
  }
  const renderAllCatches = DomHelper.query('#react-render-contest-all-catches')
  if (renderAllCatches) {
    ReactDOM.render(
      <AllCatches
        appConfig={window.initialState}
        contestId={window.initialState.contestId}
        style={window.initialState.contestStyle}
      />,
      renderAllCatches
    )
  }
  const renderTeamsElt = DomHelper.query('#react-render-contest-teams')
  if (renderTeamsElt) {
    ReactDOM.hydrate(
      <Teams
        teams={window.initialState.contestTeamsList}
        contestSeoName={window.initialState.contestSeoName}
        displayZone={window.initialState.contestSettingsTeamNeedsToChooseContestZone}
      />,
      renderTeamsElt
    )
  }
  const renderElt2 = DomHelper.query('#react-render-contest-registration-modal')
  if (renderElt2) {
    ReactDOM.render(
      <RegistrationModal
        appConfig={window.initialState}
        contestId={window.initialState.contestId}
        contestRegisterFormSettings={window.initialState.contestRegisterFormSettings}
        userEmail={window.initialState.userEmail}
        texts={window.initialState.contestTexts}
        alreadyRegistered={window.initialState.contestAlreadyRegistered}
        alreadyPreRegistered={window.initialState.contestAlreadyPreRegistered}
        contestDefautToPreRegister={window.initialState.contestDefautToPreRegister}
        isLoggedIn={window.initialState.isLoggedIn}
      />,
      renderElt2
    )
  }
  const contestSimpleRegisterButton = DomHelper.query('#contest-simple-register')
  if (contestSimpleRegisterButton) {
    contestSimpleRegisterButton.onclick = e => {
      if (e) {
        e.preventDefault()
      }
      ModalsHelper.open('#modal-register-contest')
    }
  }
  const renderElt22 = DomHelper.query('#react-render-contest-register-button')
  if (renderElt22) {
    ReactDOM.render(
      <RegisterButton
        appConfig={window.initialState}
        contestId={window.initialState.contestId}
        contestDefautToPreRegister={window.initialState.contestDefautToPreRegister}
        isLoggedIn={window.initialState.isLoggedIn}
      />,
      renderElt22
    )
  }
  const renderElt3 = DomHelper.query('#react-render-contest-start-countdown')
  if (renderElt3) {
    ReactDOM.render(
      <CountDown
        date={new Date(window.initialState.contestStartDate)}
        className="text-success"
        days={{ plural: 'J ', singular: 'J ' }}
        hours="H "
        mins="M "
        segs="S "
      />,
      renderElt3
    )
  }
  const renderElt4 = DomHelper.query('#react-render-contest-end-countdown')
  if (renderElt4) {
    ReactDOM.render(
      <CountDown
        date={new Date(window.initialState.contestEndDate)}
        days={{ plural: 'J ', singular: 'J ' }}
        hours="H "
        mins="M "
        segs="S "
      />,
      renderElt4
    )
  }
  const renderElt5 = DomHelper.query('#react-render-contest-join-team')
  if (renderElt5) {
    ReactDOM.render(
      <JoinContestTeam
        appConfig={window.initialState}
        contestId={window.initialState.contestId}
        contestMaxNumberOfPeopleInTeam={window.initialState.contestMaxNumberOfPeopleInTeam}
        isLoggedIn={window.initialState.isLoggedIn}
        contestRegistration={window.initialState.contestRegistration}
      />,
      renderElt5
    )
  }
  const registerWithPayementElt = DomHelper.query('#react-render-contest-register-with-payment')
  if (registerWithPayementElt) {
    ReactDOM.render(
      <RegisterWithPayment
        locale={window.initialState.locale.identifierShort}
        appConfig={window.initialState}
        contestId={window.initialState.contestId}
        needTeams={window.initialState.needTeams}
        stripeRedirectQueryParams={window.initialState.stripeRedirectQueryParams}
      />,
      registerWithPayementElt
    )
  }

  const rankingElt = DomHelper.query('#react-render-ranking')
  if (rankingElt) {
    ReactDOM.hydrate(
      <Ranking
        locale={window.initialState.locale.identifierShort}
        rounds={window.initialState.contestRankingRounds}
        ranking={window.initialState.contestRanking}
        contestId={window.initialState.contestId}
        teamsById={window.initialState.contestTeamsById}
        contestSeoName={window.initialState.contestSeoName}
        scoreLessIsMore={window.initialState.contestScoreLessIsMore}
        lastRoundCountsAsTotal={window.initialState.contestLastRoundCountsAsTotal}
      />,
      rankingElt
    )
  }
  const renderElt6 = DomHelper.query('#react-render-ranking-no-rounds')
  if (renderElt6) {
    ReactDOM.hydrate(
      <RankingNoRounds
        locale={window.initialState.locale.identifierShort}
        ranking={window.initialState.contestRanking}
        contestId={window.initialState.contestId}
        teamsById={window.initialState.contestTeamsById}
        contestSeoName={window.initialState.contestSeoName}
        scoreLessIsMore={window.initialState.contestScoreLessIsMore}
      />,
      renderElt6
    )
  }
  const individualRankingRoundElt = DomHelper.query('#react-render-individual-ranking-rounds')
  if (individualRankingRoundElt) {
    ReactDOM.hydrate(
      <IndividualRankingRounds
        locale={window.initialState.locale.identifierShort}
        appConfig={window.initialState}
        contestId={window.initialState.contestId}
        ranking={window.initialState.contestIndividualRankingRounds}
        rounds={window.initialState.contestRankingRounds}
        scoreLessIsMore={window.initialState.contestScoreLessIsMore}
        lastRoundCountsAsTotal={window.initialState.contestLastRoundCountsAsTotal}
      />,
      individualRankingRoundElt
    )
  }
  const individualRankingNoRoundElt = DomHelper.query('#react-render-individual-ranking-no-rounds')
  if (individualRankingNoRoundElt) {
    ReactDOM.hydrate(
      <IndividualRankingNoRounds
        locale={window.initialState.locale.identifierShort}
        ranking={window.initialState.contestIndividualRankingNoRounds}
        contestId={window.initialState.contestId}
        contestSeoName={window.initialState.contestSeoName}
        scoreLessIsMore={window.initialState.contestScoreLessIsMore}
      />,
      individualRankingNoRoundElt
    )
  }
  const contestStatsTableElt = DomHelper.query('#react-render-contest-stats-table')
  if (contestStatsTableElt) {
    ReactDOM.hydrate(
      <ContestStatsTable
        locale={window.initialState.locale.identifierShort}
        stats={window.initialState.contestStatsTable}
      />,
      contestStatsTableElt
    )
  }
  const renderElt7 = DomHelper.query('#react-render-contest-join-with-password')
  if (renderElt7) {
    ReactDOM.render(
      <JoinContestWithPassword
        appConfig={window.initialState}
        contestId={window.initialState.contestId}
        isLoggedIn={window.initialState.isLoggedIn}
        contestRegistration={window.initialState.contestRegistration}
      />,
      renderElt7
    )
  }

  const allCountDowns = DomHelper.queryAll('.react-count-down')
  allCountDowns.forEach(elt => {
    const endDate = DomHelper.data(elt, 'count-down-end')
    ReactDOM.render(
      <CountDown
        date={new Date(parseFloat(endDate))}
        days={{ plural: 'D ', singular: 'D ' }}
        hours=":"
        mins=":"
        segs=""
      />,
      elt
    )
  })

  const { mapboxgl } = window
  if (mapboxgl) {
    initMap(mapboxgl)
  }
})

if (module.hot) {
  module.hot.accept()
}
